import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'app-select-cell-renderer',
  template: `
    @if (editable) {
      <span class="select-trigger">
        <span class="ci-text-md" [class.select-placeholder]="!hasValue">{{ displayValue }}</span>
        <i class="ph ph-caret-down select-caret"></i>
      </span>
    } @else {
      <span>{{ displayValue }}</span>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
      }

      .select-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      .select-placeholder {
        color: var(--colors-text-quaternary);
      }

      .select-caret {
        flex-shrink: 0;
        margin-left: var(--spacing-md);
        font-size: 24px;
        color: var(--colors-text-tertiary);
      }
    `
  ],
  standalone: true
})
export class SelectCellRendererComponent implements ICellRendererAngularComp {
  displayValue = '';
  editable = false;
  hasValue = false;

  agInit(params: ICellRendererParams): void {
    this.update(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.update(params);
    return true;
  }

  private update(params: ICellRendererParams): void {
    const editableDef = params.colDef?.editable;
    this.editable = typeof editableDef === 'function' ? editableDef(params as any) : editableDef === true;
    this.hasValue = params.value != null;
    this.displayValue = params.valueFormatted ?? params.value ?? '';
  }
}
